export const centsToDollars = (amt) => {
  return amt / 100;
};
